import { SignIn } from '@clerk/clerk-react'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import { APP_BASE_PATH } from '@/app.const'
import { AUTH_CLERK_APPEARANCE } from '@/components/auth/auth-clerk-appearance.const'
import { AuthLayout } from '@/components/auth/auth-layout.layout'
import { rootRoutes } from '@/routes/org-routes.const'

export const SignInPage = (): ReactNode => {
  const location = useLocation()

  const from = (location.state as { from?: string })?.from ?? `${APP_BASE_PATH}/`

  return (
    <AuthLayout
      heading={
        <>
          SEMrush. Ahrefs. Lighthouse.
          <br className="hidden xl:block" /> All included.
        </>
      }
    >
      <SignIn
        appearance={AUTH_CLERK_APPEARANCE}
        signUpUrl={`${APP_BASE_PATH}/${rootRoutes.signUp}`}
        fallbackRedirectUrl={from}
        forceRedirectUrl={from}
      />
    </AuthLayout>
  )
}
